import React from "react"
import {UseFormReturn} from "react-hook-form";
import {ErrorResponse, MatesSelect, RestResponse, withUseFormHook} from "@sinossi/mates-react-library";
import * as Yup from "yup"
import {WorkflowObjectType} from "../../models";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {t, Trans} from "@lingui/macro";
import {WorkflowService} from "../../services/workflow.service";
import {MatesComponent, MatesComponentState} from "../mates-component";
import {UseRouterParams} from "../../services/router";

interface TemplateSelectionModalProps extends UseFormReturn, UseRouterParams {
    templateType: WorkflowObjectType

    onClose: () => void
    submit: (templateId: string) => void
}

interface TemplateSelectionModalState extends MatesComponentState {
    templateList: {
        id: string,
        name: string
    }[]
    loading: boolean
}

const TemplateValidationSchema = Yup.object().shape({
    templateId: Yup.string().required("Il campo è obbligatorio.")
})

class TemplateSelectionModal extends React.Component<TemplateSelectionModalProps, TemplateSelectionModalState>
{
    private readonly matesComponent: MatesComponent<TemplateSelectionModalProps,TemplateSelectionModalState > = new MatesComponent(this)

    constructor(props: TemplateSelectionModalProps) {
        super(props)
        this.state = {
            ...this.matesComponent.setupState(),
            templateList: [],
            loading: true
        }
    }

    componentDidMount() {
        this.getTemplates()
    }

    private getTemplates = () => {
        WorkflowService.getTemplateListByType(this.props.templateType, this.getTemplatesCallback, this.matesComponent.onError)
    }

    private getTemplatesCallback = (response: RestResponse<any, ErrorResponse>) => {
        if(response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        if (response.data) {
            this.setState(() => ({
                templateList: response.data,
                loading: false
            }))
        }
    }

    private submit = (values: any) => {
        const templateId = this.props.getValues("templateId")

        this.props.submit(templateId)
        this.props.onClose()
    }

    render(){
        return(
            <Dialog open={true} onClose={this.props.onClose} maxWidth={"md"} fullWidth>
                <DialogTitle>
                    <Trans id={"template-selection-modal.title"}>
                        Crea Workflow
                    </Trans>
                </DialogTitle>
                <form onSubmit={this.props.handleSubmit(this.submit)}>
                    <DialogContent>
                        <Typography fontSize={"1rem"} sx={{mb: 3}}>
                            <Trans id="template-selection-modal.body">
                                Seleziona template di riferimento.
                            </Trans>
                        </Typography>
                        <MatesSelect variant={"outlined"}
                                     label={t({
                                         id: "template-selection-modal.template-id",
                                         message: "Nome template",
                                     })}
                                     name="templateId"
                                     control={this.props.control}
                                     trigger={this.props.trigger}
                                     formState={this.props.formState}
                        >
                            {this.state.templateList.map((template) => (
                                <option value={template.id} key={template.id}>
                                    {template.name}
                                </option>
                            ))}
                        </MatesSelect>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.onClose}
                                variant={"contained"}
                                color="neutral"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation>
                            <Trans id={"template-selection-modal.close-button"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: 'secondary.main',
                                    color: 'white',
                                    mr: 1,
                                    textTransform: "none",
                                    width: 100
                                }}
                        >
                            <Trans id={"template-selection-modal.create-button"}>
                                Crea
                            </Trans>
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        )
    }
}

export default withUseFormHook<{}>(
    TemplateSelectionModal,
    TemplateValidationSchema,
    {}
)
